module.exports = __webpack_public_path__ + "static/media/position.515235fe.svg";